import script from "./VueCommand.vue?vue&type=script&setup=true&lang=js"
export * from "./VueCommand.vue?vue&type=script&setup=true&lang=js"

import "./VueCommand.vue?vue&type=style&index=0&id=a0dcac16&lang=scss"

const __exports__ = script;

export default __exports__